import { Navigate, Route, Routes } from "react-router-dom";
import { AppProviders } from "./providers/AppProviders";
import { DashboardLayout } from "./components/layout/DashboardLayout";
import { ProtectedRoute } from "./components/routing/ProtectedRoute";
import { LoginPage } from "./pages/LoginPage";
import { OverviewPage } from "./pages/OverviewPage";
import { AgentsPage } from "./pages/AgentsPage";
import { WidgetsPage } from "./pages/WidgetsPage";
import { ChatsPage } from "./pages/ChatsPage";
import { AnalyticsPage } from "./pages/AnalyticsPage";
import { useBootstrapAuth } from "./hooks/useBootstrapAuth";

const AppRoutes = () => {
  useBootstrapAuth();

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<DashboardLayout />}>
          <Route index element={<Navigate to="/dashboard/overview" replace />} />
          <Route path="/dashboard/overview" element={<OverviewPage />} />
          <Route path="/dashboard/agents" element={<AgentsPage />} />
          <Route path="/dashboard/widgets" element={<WidgetsPage />} />
          <Route path="/dashboard/chats" element={<ChatsPage />} />
          <Route path="/dashboard/analytics" element={<AnalyticsPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/dashboard/overview" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <AppProviders>
      <AppRoutes />
    </AppProviders>
  );
}

export default App;
